export const caseStudiesData = [
  {
    id: 'ysl-traders-ai-chatbot',
    title: 'AI Chatbot Transformation for YSL Traders',
    client: 'YSL Traders',
    industry: 'Trading & Commerce',
    category: 'AI & Data',
    icon: '🤖',
    challenge: 'YSL Traders needed a solution to handle increasing customer inquiries while maintaining high-quality service. Manual customer support was becoming a bottleneck.',
    solution: 'We developed a custom AI-powered chatbot that integrates seamlessly with their existing systems, providing 24/7 customer support with natural language processing capabilities.',
    results: [
      '40% reduction in response times',
      'Significant increase in customer satisfaction',
      '24/7 automated customer support',
      'Reduced workload on support team'
    ],
    technologies: ['AI/ML', 'NLP', 'Chatbot Integration', 'API Development'],
    image: null, // Can add image path later
    testimonial: {
      quote: "SolveDot Labs' AI chatbot transformed our customer service. We've seen a 40% reduction in response times and a huge spike in customer satisfaction.",
      author: "Aditi",
      company: "YSL Traders"
    }
  },
  {
    id: 'brainyhand-iot-smart-home',
    title: 'IoT Smart Home System for Brainyhand Automation',
    client: 'Brainyhand Automation',
    industry: 'Home Automation',
    category: 'IoT',
    icon: '💡',
    challenge: 'Brainyhand Automation required a reliable, scalable IoT system for smart home automation with zero downtime guarantee and seamless device integration.',
    solution: 'We built a comprehensive IoT platform with real-time device management, automated control systems, and robust connectivity protocols ensuring flawless operation.',
    results: [
      '100% uptime since deployment',
      'Seamless device integration',
      'Real-time monitoring and control',
      'Enhanced client satisfaction'
    ],
    technologies: ['IoT', 'MQTT', 'Real-time Processing', 'Device Management'],
    image: null,
    testimonial: {
      quote: "The IoT smart home system is flawless. The reliability and zero downtime promise is not just a claim—it's a reality. Our clients are thrilled.",
      author: "Bhushan",
      company: "Brainyhand Automation"
    }
  },
  {
    id: 'ysl-traders-crm',
    title: 'Custom CRM Solution for YSL Traders',
    client: 'YSL Traders',
    industry: 'Trading & Commerce',
    category: 'Web Development',
    icon: '💼',
    challenge: 'YSL Traders needed a custom CRM system tailored to their specific sales processes and workflows, with intuitive design and powerful features.',
    solution: 'We developed a fully customized CRM platform with lead management, deal tracking, analytics dashboards, and seamless integration with their existing tools.',
    results: [
      '100% uptime since launch',
      'Intuitive and powerful interface',
      'Streamlined sales processes',
      'Became the backbone of sales team'
    ],
    technologies: ['Web Development', 'CRM', 'Database Design', 'API Integration'],
    image: null,
    testimonial: {
      quote: "The custom CRM they built for us is intuitive, powerful, and has had 100% uptime since launch. It's the backbone of our sales team now.",
      author: "Lalit",
      company: "YSL Traders"
    }
  }
];

